export function checkHighAndThick(totalItems, current) {
  if (totalItems < 3) return null;

  const isLast = current === totalItems;

  const lastSpecialPosition = 3 + Math.floor((totalItems - 3) / 5) * 5;

  return lastSpecialPosition === totalItems && isLast
    ? lastSpecialPosition
    : null;
}

export function checkBeforeHighAndThick(highAndThickPosition, current) {
  return highAndThickPosition !== null && current === highAndThickPosition - 1;
}
